import SayKitWeb from '@whitesharx/starfall-frontend-saykit-web';

import { ANDROID_CLICK_URL, ANDROID_VIEW_URL, IOS_CLICK_URL, IOS_VIEW_URL } from './constants';

const urlMapping = {
  view: {
    ios: IOS_VIEW_URL,
    android: ANDROID_VIEW_URL,
  },
  click: {
    ios: IOS_CLICK_URL,
    android: ANDROID_CLICK_URL,
  },
};

export const buildDeeplink = (type: 'view' | 'click', platform: 'ios' | 'android', creative: string) => {
  const url = urlMapping[type][platform];

  const params = new URLSearchParams(SayKitWeb.getUTMParameters());
  const resultParams = new URLSearchParams();

  if (params.get('utm_source')) {
    resultParams.append('sgn', 'website');
    resultParams.append('campaign', `${params.get('utm_source')} (${params.get('utm_campaign')})`);
    resultParams.append('creative', creative);
    resultParams.append('sgclid', params.get('gclid') || '');
  } else {
    resultParams.append('sgn', 'website');
    resultParams.append('campaign', 'organic');
    resultParams.append('creative', creative);
  }

  return url + '?' + resultParams.toString();
};
